import React, { useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import StoresMap from "./StoresMap";
import StoresList from "./StoresList";
import franchiseeStores from "../../data/franchisees.json";

const StoreLocator = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const validStores = franchiseeStores
    .map((store, index) => ({
      ...store,
      id: index,
      lat: +store.coordinates?.lat,
      lng: +store.coordinates?.long,
    }))
    .filter((store) => !isNaN(store.lat) && !isNaN(store.lng));

  const [selectedStoreId, setSelectedStoreId] = useState(null);

  return (
    <Box sx={{ width: "100%", mx: "auto" }}>
      {/* Heading */}
      <Typography
        variant="h3"
        fontWeight={800}
        sx={{
          textAlign: "center",
          color: "var(--secondary-blue)",
          mb: { xs: 1.5, md: 1 },
          fontSize: { xs: "1.8rem", md: "2.5rem" },
        }}
      >
        Visit Our Locations
      </Typography>

      {/* Subheading */}
      <Typography
        variant="h4"
        fontWeight={600}
        sx={{
          textAlign: "center",
          color: "text.primary",
          mb: { xs: 3, md: 4 },
          fontSize: { xs: "1.1rem", md: "1.5rem" },
        }}
      >
        Discover Skymart around Canada
      </Typography>

      {isMobile ? (
        // --- MOBILE LAYOUT: List above map ---
        <>
          <Box
            sx={{
              maxHeight: "40vh",
              overflowY: "auto",
              px: 2,
              mb: 2,
            }}
          >
            <StoresList
              stores={validStores}
              selectedStoreId={selectedStoreId}
              onSelectStore={setSelectedStoreId}
            />
          </Box>
          <Box sx={{ width: "100%", height: "50vh" }}>
            <StoresMap
              stores={validStores}
              selectedStoreId={selectedStoreId}
              onSelectStore={setSelectedStoreId}
            />
          </Box>
        </>
      ) : (
        // --- DESKTOP LAYOUT: Map with floating list ---
        <Box sx={{ position: "relative", width: "100%", height: "80vh" }}>
          <StoresMap
            stores={validStores}
            selectedStoreId={selectedStoreId}
            onSelectStore={setSelectedStoreId}
          />
          <Box
            sx={{
              position: "absolute",
              top: "2rem",
              left: "2rem",
              width: { md: "400px", lg: "460px" },
              maxHeight: "80%",
              overflow: "hidden",
              background: "rgba(255, 255, 255, 0.85)",
              backdropFilter: "blur(6px)",
              borderRadius: "1rem",
              boxShadow: "0 6px 18px rgba(0, 0, 0, 0.08)",
              p: 2,
              zIndex: 2,
            }}
          >
            <StoresList
              stores={validStores}
              selectedStoreId={selectedStoreId}
              onSelectStore={setSelectedStoreId}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default StoreLocator;
